import { inject, Injectable, signal } from '@angular/core';
import { IToast } from '../interfaces/toast.interface';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly _toasts = signal<IToast[]>([]);
  public readonly toasts = this._toasts.asReadonly();

  private translateService = inject(TranslateService);

  public show(toast: IToast, replaceExisting = false) {
    if (replaceExisting) {
      const existingToast = this._toasts().find(
        (toastToFind) =>
          toastToFind.header === toast.header &&
          toastToFind.message === toast.message &&
          toastToFind.classname === toast.classname &&
          toastToFind.buttonClassname === toast.buttonClassname &&
          toastToFind.delay === toast.delay
      );

      if (existingToast) {
        this.remove(existingToast);
      }
    }
    this._toasts.update((toasts) => [...toasts, toast]);
  }

  public remove(toast: IToast) {
    this._toasts.update((toasts) => toasts.filter((t) => t !== toast));
  }

  public clear() {
    this._toasts.set([]);
  }

  public showGeneralErrorToast(errorMessage?: string, replaceExisting = false): void {
    this.show(
      {
        header: this.translateService.instant('error.toast.title'),
        message: errorMessage || 'error.toast.text',
        classname: 'bg-danger-subtle',
        buttonClassname: 'text-body',
        delay: 10000,
      },
      replaceExisting
    );
  }
}
